import { useMemo } from "react";
import {
	ClientPortfolioInvestmentFrequencyEnum,
	ClientPortfolioInvestmentTypeEnum,
} from "web_myplann/Infrastructure/Api/Api";
import { Resources } from "web_myplann/Infrastructure/Translations/Resources";
import {
	EXCLUDED_INSTRUCTION_FREQUENCIES,
	EXCLUDED_INSTRUCTION_TYPES,
	INSTRUCTION_CURRENCIES,
} from "web_myplann/Portfolio/Forms/ToolsShared/constants";
import { useEnumSelectOptions } from "web_myplann/Shared/Hooks/useEnumSelectOptions";

export type InstructionTypeLabels = "investment" | "bankProduct";

export const useInstructionTypeOptions = (
	labels: InstructionTypeLabels = "investment",
) =>
	useEnumSelectOptions(
		ClientPortfolioInvestmentTypeEnum,
		labels === "bankProduct"
			? Resources.PortfolioDetail.ToolHistory.ActionTypeBankProduct
			: Resources.PortfolioDetail.ToolHistory.ActionType,
		EXCLUDED_INSTRUCTION_TYPES,
	);

export const useInstructionFrequencyOptions = () =>
	useEnumSelectOptions(
		ClientPortfolioInvestmentFrequencyEnum,
		Resources.PortfolioDetail.ToolHistory.Fund.Frequency,
		EXCLUDED_INSTRUCTION_FREQUENCIES,
	);

export const useInstructionCurrencyOptions = () =>
	useMemo(
		() =>
			INSTRUCTION_CURRENCIES.map((currency) => ({
				value: currency,
				label: currency,
			})),
		[],
	);
